// extracted by mini-css-extract-plugin
export default {"button":"CardSwitchButton_button__SscQS","title":"CardSwitchButton_title__84Ghm"};